import styled from 'styled-components';
export const Container = styled.ul `
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    width: 260px;
    background: ${({ theme }) => theme === null || theme === void 0 ? void 0 : theme.color.darker1};
    border-radius: 4px;
    color: white;
    overflow-y: auto;
    max-height: 60vh;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: ${({ theme }) => (theme === null || theme === void 0 ? void 0 : theme.color.darker1) || 'gray'};
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => (theme === null || theme === void 0 ? void 0 : theme.color.lighter1) || 'darkgray'};
        border-radius: 4px;
    }
`;
//# sourceMappingURL=index.js.map